/**
 * Kapanmış 6/7 hesaplarda (bakiye 0, borç=alacak toplam) ATB ham/nihai 0 kalır.
 * Kaynak mizan hareket tutarından ATB işaretini (borç−alacak) üretir.
 */

function num(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

function isContraRevenue(accountCode) {
  const code = String(accountCode || '');
  const codeNum = parseFloat(code) || 0;
  const prefix =
    code.startsWith('63') ||
    code.startsWith('65') ||
    code.startsWith('68') ||
    code.startsWith('690');
  return (
    prefix ||
    (codeNum >= 610 && codeNum <= 639) ||
    (codeNum >= 650 && codeNum <= 669) ||
    (codeNum >= 680 && codeNum <= 689) ||
    codeNum === 690 ||
    codeNum === 691 ||
    codeNum === 692
  );
}

/** Gelir (6): credit−debit (UI gelir tablosu). */
function incomeAmount(accountCode, debitBalance, creditBalance, debitTotal, creditTotal) {
  const diff = num(creditBalance) - num(debitBalance);
  const contra = isContraRevenue(accountCode);
  if (diff !== 0) return contra ? -Math.abs(diff) : diff;
  const credit = num(creditTotal);
  const debit = num(debitTotal);
  if (credit > debit) return contra ? -credit : credit;
  if (debit > credit) return -debit;
  const equalAmount = Math.max(credit, debit);
  return contra ? -equalAmount : equalAmount;
}

/** Gider (7): borç−alacak. */
function expenseAtbAmount(debitBalance, creditBalance, debitTotal, creditTotal) {
  const diff = num(debitBalance) - num(creditBalance);
  if (diff !== 0) return diff;
  const debit = num(debitTotal);
  const credit = num(creditTotal);
  if (debit !== credit) return debit - credit;
  return Math.max(debit, credit);
}

/**
 * @param {Array<Record<string, unknown>>} agacRows adjusted trial balance satırları
 * @param {Array<{ accountCode: string, totalBorcBakiyesi?: number, totalAlacakBakiyesi?: number, totalBorcToplami?: number, totalAlacakToplami?: number }>|null} groupedMizan
 */
export function enrichClosedIncomeExpenseAgac(agacRows, groupedMizan) {
  if (!Array.isArray(agacRows) || agacRows.length === 0) return agacRows;
  if (!Array.isArray(groupedMizan) || groupedMizan.length === 0) return agacRows;

  const byCode = new Map(groupedMizan.map((g) => [String(g.accountCode || '').trim(), g]));

  return agacRows.map((row) => {
    const code = String(row?.hesapKodu || '').trim();
    if (!code) return row;
    const first = code.charAt(0);
    if (first !== '6' && first !== '7') return row;
    if (num(row.hamTutar) !== 0 || num(row.nihaiTutar) !== 0 || num(row.degisimTutar) !== 0) {
      return row;
    }
    const group = byCode.get(code);
    if (!group) return row;

    let atb = 0;
    if (first === '6') {
      // Gelir tablosu credit−debit; ATB borç−alacak → işaret ters
      atb = -incomeAmount(
        code,
        group.totalBorcBakiyesi,
        group.totalAlacakBakiyesi,
        group.totalBorcToplami,
        group.totalAlacakToplami,
      );
    } else {
      atb = expenseAtbAmount(
        group.totalBorcBakiyesi,
        group.totalAlacakBakiyesi,
        group.totalBorcToplami,
        group.totalAlacakToplami,
      );
    }
    if (atb === 0) return row;
    return {
      ...row,
      hamTutar: atb,
      degisimTutar: 0,
      nihaiTutar: atb,
    };
  });
}
